<template>
	<div>
		<home-nav></home-nav>
		<div class="main-top">
			<div id="search-bar">
				<div class="container">
					<search :service="search.service" :location="search.location"></search>
				</div>
			</div>
			<div id="main-content-area" class="container mt-md-3">
				<div class="row no-gutters">

					<div id="main-content" class="col-lg-9 col-xl-9 order-lg-12">
						<div id="salon-container" class="container">
							<div style="padding: 25px 0px;" v-if="fetching" class="fetching">
								<loader color="red"></loader>
							</div>
							<div v-else class="row">
								<div class="col-12">
									<div class="saloni-list-heading">
										<span>Pronađeno {{salons.length}} rezultata</span>
										<!--
										<form class="saloni-list-sort">
											<select class="custom-select">
												<option value="random">Random</option>
												<option value="trending">Trending</option>
												<option value="higher price">Higher price</option>
												<option value="lower price">Lower price</option>
												<option value="by ratings">Lower price</option>
											</select>
										</form>
										-->
									</div>
								</div>
								<div class="col-12">
									<div v-if="data.length == 0" class="alert alert-danger text-center">
										<p class="m-0">Nema pronađenih rezultata.</p>
									</div>
								</div>
								<div v-for="(sal,index) in data" :key="index" class="col-12">
									<router-link :to="'/salon/'+sal.name">
										<div class="content-box-list">
											<div class="row">
												<div class="col-11 d-md-none">
													<h3>{{sal.name}}</h3>
													<div class="saloni-list-stats">
														<div class="saloni-list-ratings">
															<span :class="sal.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
															<span :class="sal.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
															<span :class="sal.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
															<span :class="sal.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
															<span :class="sal.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
														</div>
														<div class="saloni-list-comm">
															<span class="fa fa-comments"></span><small> ({{sal.comment_count}})</small>
														</div>
														<div class="saloni-list-heart">
															<span class="fa fa-heart"></span><small> ({{sal.favorites}})</small>
														</div>

													</div>
												</div>
												<div class="col-md-5">
													<!--<div class="row no-gutters">
														<div class="col-12">
															<div class="img-wrapper">
																<img :src="sortImages(sal.images).profile_picture" class="img-responsive">
															</div>
														</div>
														<div v-for="(img,index) in sortImages(sal.images).featured_picture" :key="index" class="col-4">
															<div class="img-wrapper">
																<img :src="img.filename" alt="" class="img-responsive">
															</div>
														</div>
													</div> -->
													
													<div class="row no-gutters">
														<div class="col-12">
															<div class="img-wrapper-list-pr" v-bind:style="{ backgroundImage: 'url(' + sortImages(sal.images).profile_picture + ')' }"></div>
														</div> 
														<div v-for="(img,index) in sortImages(sal.images).featured_picture" :key="index" class="col-4">
															<div class="img-wrapper-list-ft" v-bind:style="{ backgroundImage: 'url(' + img.filename + ')' }"></div>
														</div> 
													</div>
													
												</div>
												<div class="col-md-7">
													<div class="d-none d-md-block">
														<h3>{{sal.name}}</h3>
														<p class="saloni-list-adresa">{{sal.address}}, {{sal.city}}</p>
														<div class="saloni-list-stats">
															<div class="saloni-list-ratings">
																<span :class="sal.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="sal.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="sal.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="sal.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
																<span :class="sal.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
															</div>
															<div class="saloni-list-comm">
																<span class="fa fa-comments"></span><small> ({{sal.comment_count}})</small>
															</div>
															<div class="saloni-list-heart">
																<span class="fa fa-heart"></span><small> ({{sal.favorites}})</small>
															</div>

														</div>
													</div>
													<div class="col-12">
														<table id="table-frizure" class="table table-sm">
															<tbody>
																<!-- @foreach(array_slice($data->services,0,3) as $service) -->
																<tr v-for="(serv,index) in sal.featured_services" :key="index">
																	<td class="text-left-list">
																		<p> {{serv.name}}</p>
																		<small>{{serv.description}}</small>
																	</td>
																	<td class="text-right td-flex">
																		<div class="td-2">
																			<p>{{serv.price}} kn</p>
																			<small>{{serv.time}} min</small>
																		</div>
																		<!-- <div class="td-1"><router-link :to="'salon/'+sal.name+'#book'+serv.id" class="btn fs-btn small dark book">Book</router-link></div> -->
																	</td>
																</tr>
																<!-- @endforeach -->
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</router-link>
								</div>
							</div>
							<nav v-if="salons.length > 0" aria-label="Page navigation">
								<ul class="pagination justify-content-center">
									<li class="page-item">
										<a :class="salon_pages.prev == null ? 'bg-gray page-link':'page-link'" :href="salon_pages.prev" aria-label="Previous">
											<span aria-hidden="true">&laquo;</span>
											<span class="sr-only">Previous</span>
										</a>
									</li>
									<li v-for="(page,index) in salon_pages.pages" :key="index" :class="page.active ? 'page-item active':'page-item'"><a class="page-link" :href="page.link">{{page.label}}</a></li>
									<li class="page-item">
										<a :class="salon_pages.next == null ? 'bg-gray page-link':'page-link'" :disabled="salon_pages.next == null" :href="salon_pages.next" aria-label="Next">
											<span aria-hidden="true">&raquo;</span>
											<span class="sr-only">Next</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>

					</div>

					<div id="side-content" class="col-lg-3 col-xl-3 pb-5 order-lg-1">
						<div class="salon-container container stickey-top">
							<div class="side-content-heading">
								<h4><span class="mr-2"><i class="fas fa-filter"></i></span>Filtriraj pretragu</h4>
							</div>
							<form name="search-sidebar-form" id="search-sidebar-form" onSubmit="">
								<div class="form-group">
									<label for="exampleInputEmail1">Ocjena</label>
									<div class="custom-control custom-checkbox">
										<input @click="toggleRating(5)" v-model="filter_data[5]" name="5" type="checkbox" class="custom-control-input" id="check-ocjena-5">
										<label class="custom-control-label" for="check-ocjena-5"><span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span> (5)
										</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="toggleRating(4)" v-model="filter_data[4]" type="checkbox" class="custom-control-input" id="check-ocjena-4">
										<label class="custom-control-label" for="check-ocjena-4"><span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star"></span> (4)
										</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="toggleRating(3)" v-model="filter_data[3]" type="checkbox" class="custom-control-input" id="check-ocjena-3">
										<label class="custom-control-label" for="check-ocjena-3"><span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span> (3)
										</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="toggleRating(2)" v-model="filter_data[2]" type="checkbox" class="custom-control-input" id="check-ocjena-2">
										<label class="custom-control-label" for="check-ocjena-2"><span class="fa fa-star checked"></span>
											<span class="fa fa-star checked"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span> (2)
										</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="toggleRating(1)" v-model="filter_data[1]" type="checkbox" class="custom-control-input" id="check-ocjena-1">
										<label class="custom-control-label" for="check-ocjena-1"><span class="fa fa-star checked"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span>
											<span class="fa fa-star"></span> (1)
										</label>
									</div>

								</div>
								<div class="form-group">
									<label for="exampleInputEmail1">Ostalo</label>
									<div class="custom-control custom-checkbox">
										<input @click="filterData('action')" v-model="search.action" type="checkbox" class="custom-control-input" id="check-akcija">
										<label class="custom-control-label" for="check-akcija">Akcija</label>
									</div>
									<!-- <div class="custom-control custom-checkbox">
										<input @click="filterData('weekend')"  v-model="search.weekend" type="checkbox" class="custom-control-input" id="check-vikend">
										<label class="custom-control-label" for="check-vikend">Otvoreni vikendom</label>
									</div> -->
									<!-- <div class="custom-control custom-checkbox">
										<input @click="filterData('address')"  v-model="search.address" type="checkbox" class="custom-control-input" id="check-adresa">
										<label class="custom-control-label" for="check-adresa">Dolazak na adresu</label>
									</div> -->
									<div class="custom-control custom-checkbox">
										<input @click="filterData('disabilities')" v-model="search.disabilities" type="checkbox" class="custom-control-input" id="check-Pristup">
										<label class="custom-control-label" for="check-Pristup">Pristup osobama s invaliditetom</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="filterData('parking')" v-model="search.parking" type="checkbox" class="custom-control-input" id="check-parking">
										<label class="custom-control-label" for="check-parking">Dostupan parking</label>
									</div>
									<div class="custom-control custom-checkbox">
										<input @click="filterData('wifi')" v-model="search.wifi" type="checkbox" class="custom-control-input" id="check-Wifi">
										<label class="custom-control-label" for="check-Wifi">Wifi</label>
									</div>
								</div>
								<!-- <div class="text-center form-group">
									<button @click="fetch(search)" type="button" class="btn fs-btn small dark" id="">Pretraži</button>
								</div> -->
							</form>
						</div>
					</div>

				</div>
			</div>
		</div>
		<home-footer></home-footer>
	</div>
</template>

<script>
	import search from '../layouts/search'
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'salon-list',
		components: {
			search
		},
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				salons: (state) => state.salons,
			})
		},
		data() {
			return {
				fetching: false,
				search: {
					service: '',
					location: '',
					page: 1,
					type: '',
					from: '',
					to: '',
					rate: 0,
					action: false,
					weekend: false,
					disabilities: false,
					address: false,
					parking: false,
					wifi: false,
				},
				filter_data: {
					5: false,
					4: false,
					3: false,
					2: false,
					1: false,
					0: false
				},
				salon_pages: {
					pages: [],
					prev: '',
					next: '',
				},
				data: []
			}
		},
		methods: {
			toggleRating(rate) {
				this.search.rate = rate == this.search.rate ? 0 : rate;
				// this.filter={5:false,4:false,3:false,2:false,1:false};
				this.filter_data[rate] = !this.filter_data[rate];
				this.filterData();
			},
			filterData(key = '') {
				if (key != '') {
					this.search[key] = !this.search[key];
				}

				var data = this.$store.state.salons;
				if (this.search.rate >= 0) {
					if (!(!this.filter_data[0] && !this.filter_data[1] && !this.filter_data[2] && !this.filter_data[3] && !this.filter_data[4] && !this.filter_data[5])) {
						data = data.filter((d) => {
							return this.filter_data[parseInt(d.rating)]
						});
					}

				}
				if (this.search.wifi) {
					data = data.filter((d) => parseInt(d.wifi) == 1);
				}
				if (this.search.parking) {
					data = data.filter((d) => parseInt(d.parking) == 1);
				}
				if (this.search.action) {
					data = data.filter((d) => parseInt(d.featured) == 1);
				}
				if (this.search.disabilities) {
					data = data.filter((d) => parseInt(d.inviting_persons) == 1);
				}
				this.data = data;
			},
			fetch(load) {
				console.log(load);
				this.fetching = true;
				this.$store.state.loader = true;
				this.$store.dispatch('post', {
						details: load,
						endpoint: this.endpoint + 'search?page=' + load.page
					})
					.then((data) => {
						console.log(data);
						data.data.data = data.data.data.map((salon) => {
							salon.services_all = salon.services_all.filter((d) => {
								return d.featured == 1 && salon.services.find((y) => y.id == d.id) == null
							});
							salon.services_all = salon.services_all.slice(0, (3 - salon.services.length) > salon.services_all.length ? salon.services_all.length : (3 - salon.services.length));
							return salon;
						});

						//sorting service which must not be more than 3
						data.data.data = data.data.data.map((d) => {
							d.featured_services = [...d.services.slice(0, d.services.length > 3 ? 3 : d.services.length)];
							if (d.featured_services.length < 3) {
								var more = d.all_services.filter((s) => {
									return d.featured_services.find((r) => r.id == s.id) == undefined;
								});
								if (more.length <= (3 - d.featured_services.length)) {
									d.featured_services = [...d.services, ...more];
								} else {
									d.featured_services = [...d.services, ...more.slice(0, (3 - d.featured_services.length))];
								}
							}
							return d;
						});

						this.$store.state.salons = data.data.data;
						this.data = this.salons;
						this.processPages(data.data);
						this.fetching = false;
						this.$store.state.loader = false;
						this.filterData();
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.fetching = false;
						this.$store.state.loader = false;
					});
			},
			processPages(data) {
				var path = this.$route.path;
				path += "?service=" + this.search['service'];
				for (var field in this.search) {
					if (field != 'service' && field != 'page' && this.search[field] != '') {
						path += '&' + field + '=' + this.search[field];
					}
				}
				console.log(this.salon_pages.pages);
				this.salon_pages.pages = [];
				for (var c = 1; c <= data.last_page; c++) {
					this.salon_pages.pages.push({
						label: c,
						active: c == data.current_page ? true : false,
						link: path + '&page=' + c
					});
				}

				this.salon_pages.prev = data.current_page == 1 ? null : path + '&page=' + (data.current_page - 1);
				this.salon_pages.next = data.current_page == data.total ? null : path + '&page=' + (data.current_page + 1);
			},
			sortImages(photos) {
				var data = {
					home_picture: '',
					profile_picture: '',
					featured_picture: []
				};
				data.home_picture = photos.find((d) => d.type == 1);
				data.profile_picture = photos.find((d) => d.type == 2);
				data.featured_picture = photos.filter((d) => d.type == 3);

				if (data.featured_picture.length > 3) {
					data.featured_picture = data.featured_picture.slice(0, 3);
				}

				data.home_picture = data.home_picture != undefined ? data.home_picture.filename : ''
				data.profile_picture = data.profile_picture != undefined ? data.profile_picture.filename : ''

				return data;
			},
		},
		created() {
			if (this.$route.query.service) {
				this.search.service = this.$route.query.service;
			}

			if (this.$route.query.location) {
				this.search.location = this.$route.query.location;
			}

			if (this.$route.query.page) {
				this.search.page = this.$route.query.page;
			}

			if (this.$route.query.type) {
				this.search.type = this.$route.query.type;
			}
			if (this.$route.query.featured) {
				this.search.featured = 1;
			}
			this.fetch(this.search);
		}
	}

</script>

<style scoped>

	.pagination {
		margin-top: 40px;
		justify-content: center;
	}

</style>
